import { creatingHelpers } from 'global/common/creating';
import { uniqueKey } from 'global/common/keys';
import SettingsAreaGroupMenu from 'global/viewSettings/components/menus/SettingsAreaGroupMenu';
import SettingsAreaGroupMenuItemElement from 'global/viewSettings/components/menus/SettingsAreaGroupMenuItemElement';
import _ from 'lodash';
import React, { useMemo } from 'react'
import { firstItems } from '../SettingsAreaContext';

export const useMenuGroupElements = ({ menuAuthGroups, settingsMenu_fns, accessLevel_appUser }) => {

  const { menuItemElements, menuElementGroups } = useMemo(() => {

    let _menuElementGroups;
    const _menuItemElements = []

    if (menuAuthGroups) {

      _.forEach(menuAuthGroups, (menuGroup, mgk) => {
        let allowGroup = false
        if (accessLevel_appUser >= mgk) { allowGroup = true }

        if (allowGroup) {

          _menuElementGroups = getMenuElementGroups(menuAuthGroups, settingsMenu_fns, accessLevel_appUser)

          const { groupedItems, iconColor } = menuGroup

          // IMPORTANT: Settings - Sort the group menus by caption
          const _groupedItems = _.sortBy(groupedItems, 'caption')

          _groupedItems.forEach(groupedItem => {
            const { key: gik } = groupedItem
            const gagmElement = <SettingsAreaGroupMenu
              key={uniqueKey('mig', 'gr', gik)}
              group={{ ...groupedItem, iconColor: iconColor }}
              grpSettings={{ ...groupedItem }}
              inverse={false}
              menuElementGroups={_menuElementGroups}
            />
            if (firstItems.includes(gik)) {
              _menuItemElements.unshift(gagmElement)
            } else {
              _menuItemElements.push(gagmElement)
            }
          })
        }
      })
    }

    return { menuItemElements: _menuItemElements, menuElementGroups: _menuElementGroups }
  }, [menuAuthGroups, accessLevel_appUser])

  return { menuItemElements, menuElementGroups }
}


/**
 * 
 * @param {object} menuAuthGroups 
 * @returns a group objects containing an array, `menuItemElements` AND  a keyed object, `menuItemElementGroups`.
 * These element are the menu items that will appear where the `menu group` is clicked
 */
const getMenuElementGroups = (menuAuthGroups, settingsMenu_fns, accessLevel_appUser) => {

  const { allowProjectOption } = settingsMenu_fns ?? {}

  const menuElementGroups = {}

  if (menuAuthGroups) {
    Object.keys(menuAuthGroups).forEach((authGroupKey, index) => {

      // the authGroupKey is the authLevel
      const authGroup = menuAuthGroups[authGroupKey]

      const { groupedItems } = authGroup

      // loop the items within the authGroup
      Object.keys(groupedItems).forEach(groupedItemKey => {

        const menuItemElements = []
        const menuItemElementGroups = []

        const groupedItem = groupedItems[groupedItemKey]

        const { groupItems } = groupedItem ?? {}

        const _groupItems = _.cloneDeep(groupItems)
        const _groupItemsAdjusted = getAdjustedGroupItems(allowProjectOption, _groupItems, groupedItemKey)

        // IMPORTANT: Settings - Sort the groupItems
        creatingHelpers.createKeys(_groupItemsAdjusted)
        const groupItems_s = _.sortBy(_groupItemsAdjusted, ['_position', 'caption'])

        groupItems_s.forEach((groupItemS, index) => {
          const { key: groupItemKey } = groupItemS
          // IMPORTANT: Settings - SettingsAreaGroupMenuItemElement
          const element = <SettingsAreaGroupMenuItemElement key={uniqueKey('mig', 'gi', groupItemKey)} groupItemKey={groupItemKey} groupItem={groupItemS} index={index} />
          if (element) {
            menuItemElementGroups[groupItemKey] = element
            menuItemElements.push(element)
          }
        })

        menuElementGroups[groupedItemKey] = {
          menuItemElementGroups,
          menuItemElements
        }

      })
      // }

    })
  }

  return menuElementGroups
}

const getAdjustedGroupItems = (allowProjectOption, groupItems, groupedItemKey) => {

  const _groupItems = _.cloneDeep(groupItems)

  switch (groupedItemKey) {
    case 'pageOptions':
      if (_groupItems) {
        Object.keys(_groupItems).forEach(pageOptionKey => {
          const allow = allowProjectOption(pageOptionKey)
          if (!allow) {
            delete _groupItems[pageOptionKey]
          }
        })
      }
      break;
    default:
    // nothing 
  }

  return _groupItems

}